module.exports = __webpack_public_path__ + "img/bk-pattern.2e784d88.svg";